/* Fall 2026 display lifecycle. Read-only: no cart writes, discount changes or page reloads. */
(function () {
  'use strict';
  if (window.__lucentFallLifecycle) return;
  const configNode = document.getElementById('lucent-fall-timing');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const start = Date.parse(config.start);
  const final = Date.parse(config.final);
  const end = Date.parse(config.end);
  if (![start, final, end].every(Number.isFinite) || !(start < final && final < end)) return;
  window.__lucentFallLifecycle = true;
  let root = String(config.root || '/');
  if (!root.startsWith('/') || root.startsWith('//')) root = '/';
  root = root.replace(/\/$/, '') + '/';
  const MAX_INTERVAL = 6 * 60 * 60 * 1000;
  let serverAnchor = null;
  let performanceAnchor = 0;
  let lastSync = -Infinity;
  let timer = null;
  let inFlight = null;
  let ended = false;
  const now = () => serverAnchor === null ? Date.now() : serverAnchor + performance.now() - performanceAnchor;
  const phaseAt = value => value < start || value >= end ? 'inactive' : value >= final ? 'final' : 'active';

  function headerHeight() {
    const header = document.getElementById('site-control');
    if (header) document.documentElement.style.setProperty('--nav-height', header.clientHeight + 'px');
  }
  function hasCampaign() {
    return !!document.querySelector('[data-lucent-fall-campaign], [data-lucent-fall-only], [data-lucent-fall-grid]');
  }
  function updateTicker(phase) {
    document.querySelectorAll('[data-lucent-fall-campaign]').forEach(wrapper => {
      let changed = false;
      wrapper.querySelectorAll('a[href*="/pages/pair20-offer"],a[href*="/discount/PAIR40"]').forEach(link => {
        const label = phase === 'inactive'
          ? 'Look Sharp. See Sharper. Shop eyeglasses'
          : 'Final Week: Buy One Pair, Get a Second 40% Off · PAIR40 · Ends Nov\u00a030';
        if (link.textContent.trim() !== label) { link.textContent = label; changed = true; }
        if (phase === 'inactive') link.setAttribute('href', root + 'collections/eyeglasses');
      });
      if (phase === 'inactive') wrapper.setAttribute('data-lucent-fall-ended', '');
      const ticker = wrapper.querySelector('lucent-offers-ticker');
      if (changed && ticker && typeof ticker.build === 'function') ticker.build();
    });
  }
  function removeStaleSale() {
    document.querySelectorAll('template[data-lucent-fall-hero-fallback]').forEach(template => {
      const container = template.closest('.shopify-section') || template.parentElement;
      const hero = container && container.querySelector('.lucent-fall-hero');
      if (hero && template.content) hero.replaceWith(template.content.cloneNode(true));
      template.remove();
    });
    document.querySelectorAll('[data-lucent-fall-only]').forEach(element => { element.hidden = true; });
    document.querySelectorAll('[data-lucent-fall-expired]').forEach(element => { element.hidden = false; element.style.display = 'block'; });
    document.querySelectorAll('[data-lucent-seasonal-heading]').forEach(heading => {
      heading.textContent = heading.dataset.evergreenText || 'Everyday Favorites';
    });
    updateTicker('inactive');
    ended = true;
    window.__lucentFallEnded = true;
    requestAnimationFrame(headerHeight);
  }
  function apply() {
    const phase = phaseAt(now());
    if (phase === 'inactive') removeStaleSale();
    else if (phase === 'final' && !ended) {
      document.querySelectorAll('[data-lucent-fall-phase]').forEach(label => { label.textContent = 'Final week of the Fall Sale'; });
      updateTicker('final');
      requestAnimationFrame(headerHeight);
    }
    clearTimeout(timer);
    if (!ended && hasCampaign()) {
      const next = now() < final ? final : end;
      timer = setTimeout(() => { apply(); sync(true); }, Math.min(MAX_INTERVAL, Math.max(50, next - now() + 50)));
    }
  }
  function sync(force) {
    if (inFlight) return inFlight;
    if (!force && performance.now() - lastSync < 30000) { apply(); return Promise.resolve(); }
    lastSync = performance.now();
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3500);
    /* A fresh server Date avoids relying solely on a visitor's clock or cached Liquid 'now'. */
    inFlight = fetch(root + 'cart.js', {
      method: 'GET', cache: 'no-store', credentials: 'same-origin',
      headers: { Accept: 'application/json' }, signal: controller.signal
    }).then(response => {
      const stamp = Date.parse(response.headers.get('Date') || '');
      if (response.ok && Number.isFinite(stamp)) {
        serverAnchor = stamp;
        performanceAnchor = performance.now();
      }
      /* The cart body is never read, changed, or logged. */
    }).catch(() => {
      /* Retain the last server anchor, or use the local clock when verification is unavailable. */
    }).finally(() => {
      clearTimeout(timeout);
      inFlight = null;
      apply();
    });
    return inFlight;
  }
  const onResume = () => { if (!document.hidden && hasCampaign()) sync(false); };
  if (hasCampaign()) sync(true);
  window.addEventListener('pageshow', onResume);
  window.addEventListener('focus', onResume);
  document.addEventListener('visibilitychange', onResume);
  document.addEventListener('shopify:section:load', onResume);
})();
